import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SpinnerDots from '../spinner/dots';
import classNames from 'classnames';
import './styles.scss';

class DropDownMenu extends Component {
    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.state = {
            isOpen: false
        };
    }

    componentDidMount() {        
        document.addEventListener('click', (e) => this.handleClickOutside(e));
    }

    handleClick() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    handleClickOutside(event) {    
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
           this.close();
        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    render() {
        const props = this.props;
        return (
            <div ref={this.wrapperRef} className={classNames({
                'drop-down-menu': true,
                'drop-down-menu--is-open': this.state.isOpen
            })}>
                <button className={classNames({
                    'drop-down-menu__button': true,
                    'drop-down-menu__button--has-notifications': props.roles.numberOfUnreadNotifications > 0
                })} type="button" onClick={() => this.handleClick()}>
                    <span className="drop-down-menu__button-text">{props.text}</span>
                    <span className="drop-down-menu__button-notification"></span>
                    <SpinnerDots />
                </button>
                {!props.isLoading &&
                    <div className="drop-down-menu__menu">
                        <>
                            <ul className="drop-down-menu__menu-list">
                                <li className="drop-down-menu__menu-list-item">
                                    {props.roles.menuItems.indexOf('Delfiregister') > -1 ? <Link to="/search">Delfiregister</Link> : <span>Delfiregister</span>}
                                </li>
                                <li className="drop-down-menu__menu-list-item">
                                    {props.roles.menuItems.indexOf('Säljdistrikt') > -1  ? <Link to="/districts">Säljdistrikt</Link> : <span>Säljdistrikt</span>}
                                </li>
                                <li className="drop-down-menu__menu-list-item">
                                    {props.roles.menuItems.indexOf('Säljdistrikt foodservice') > -1  ? <Link to="/foodservice-districts">Säljdistrikt foodservice</Link> : <span>Säljdistrikt foodservice</span>}
                                </li>
                                <li className="drop-down-menu__menu-list-item">
                                    <Link to="/publications">Analyser & Insikter</Link>
                                </li>
                                <li className="drop-down-menu__menu-list-item">
                                    {props.roles.menuItems.indexOf('Bevakningar') > -1 ? <Link to="/myfeed">Bevakningar</Link> : <span>Bevakningar</span>}
                                </li>
                                <li className="drop-down-menu__menu-list-item">
                                    {props.roles.menuItems.indexOf('Filer') > -1 ? <Link to="/myfiles">Filer</Link> : <span>Filer</span>}
                                </li>
                                <li className="drop-down-menu__menu-list-item drop-down-menu__menu-list-item--statistics">
                                   {props.roles.menuItems.indexOf('Statistik') > -1 ? <Link to="/company">Statistik</Link> : <span>Statistik</span>}
                                </li>
                            </ul>

                            <ul className="drop-down-menu__menu-list drop-down-menu__menu-list--bottom">
                                <li className="drop-down-menu__menu-list-item">
                                    <Link to="/notifications" className="drop-down-menu__menu-list-item-notification-link">
                                        {props.roles.numberOfUnreadNotifications > 0 &&
                                            <span className="drop-down-menu__menu-list-item-notification">{props.roles.numberOfUnreadNotifications}</span>
                                        }<span className="drop-down-menu__menu-list-item-notification-linktext">Notifieringar</span></Link>
                                </li>
                            </ul>

                            <ul className="drop-down-menu__menu-list drop-down-menu__menu-list--submenu">
                                <li className="drop-down-menu__menu-list-item">
                                    <a href="https://kundservice.delfi.se/" target="_blank" rel="noreferrer">Kontakt & support</a>
                                </li>
                                <li className="drop-down-menu__menu-list-item">
                                    <Link to="/profile">Mitt konto</Link>
                                </li>
                                <li className="drop-down-menu__menu-list-item">
                                    <button className="drop-down-menu__logout" type="button" onClick={props.logout}>Logga ut</button>
                                </li>
                            </ul>
                        </>
                    </div>
                }
            </div>
        );
    }
};

export default DropDownMenu;